import { render, staticRenderFns } from "./ConfirmDeleteBlock.vue?vue&type=template&id=586a0d3c&scoped=true"
import script from "./ConfirmDeleteBlock.vue?vue&type=script&lang=js"
export * from "./ConfirmDeleteBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "586a0d3c",
  null
  
)

export default component.exports